(function () {
  'use strict';
  class Controller {
    constructor($window) {
      this.history = $window.history;
    }
    $back() {
      this.history.back();
    }
  }
  angular
    .module('review.update', [])
    .component('reviewUpdate', {
      controller: Controller,
      templateUrl: 'root/review/update/update-review.route.html'
    })
    .config(function ($stateProvider) {
      $stateProvider
        .state('review.update', {
          abstract: false,
          url: '/update?reviewId',
          template: '<review-update/>'
        });
    });
}());
